/* @flow */
import React, { Component } from 'react';

import type UIComponent from 'components/UIKit/types';

let baseStyle = {
  display: 'flex',
  flexDirection: 'row',
  boxSizing: 'border-box',
  position: 'relative',
  alignItems: 'stretch',
  flexShrink: 0,
  border: '0 solid #000',
  margin: 0,
  padding: 0,
  outline: 'none'
};

const Row : UIComponent = (props) => {
    let { children, style, ref, ...rest } = props; // eslint-disable-line no-redeclare

    return (
      <div style={{...baseStyle, ...style}} {...rest} ref={ref}>
        {children}
      </div>
    );
}

export default Row;
